import { vercel } from "@t3-oss/env-core/presets";
import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  extends: [vercel()],
  /**
   * Specify your server-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars.
   */
  server: {
    DATABASE_URL: z.string(),
    YOUTUBE_API_KEY: z.string(),
    SEARCHAPI_API_KEY: z.string(),
    VERCEL_PROJECT_PRODUCTION_URL: z.string().optional(),
    TRIGGER_SECRET_KEY: z.string(),
    TRIGGER_PROJECT_ID: z.string().optional(),
    TRIGGER_QUEUE_CONCURRENCY_LIMIT: z
      .string()
      .optional()
      .default("10")
      .transform((val) => parseInt(val, 10))
      .pipe(z.number()),
    RESEND_API_KEY: z.string(),
    RESEND_GENERAL_AUDIENCE_ID: z.string(),
    CTV_DRIZZLE_LOG: z
      .enum(["true", "false"])
      .transform((value) => value === "true"),
    ICHIRAN_API_URL: z.string(),
    STRIPE_SECRET_KEY: z.string(),
    STRIPE_WEBHOOK_SECRET: z.string(),
    NODE_ENV: z
      .enum(["development", "test", "production"])
      .default("development"),
  },

  /**
   * Specify your client-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars. To expose them to the client, prefix them with
   * `NEXT_PUBLIC_`.
   */
  client: {
    NEXT_PUBLIC_CTV_LOG_LEVEL: z
      .enum(["debug", "info", "warn", "error"])
      .default("info"),
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string(),
    NEXT_PUBLIC_CLERK_SIGN_IN_URL: z.string().optional(),
    NEXT_PUBLIC_CLERK_SIGN_UP_URL: z.string().optional(),
    NEXT_PUBLIC_INFO_SITE_URL: z.string(),
    NEXT_PUBLIC_VERCEL_ENV: z
      .enum(["development", "test", "production", "preview"])
      .optional(),
  },

  /**
   * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
   * middlewares) or client-side so we need to destruct manually.
   */
  experimental__runtimeEnv: {
    NEXT_PUBLIC_CTV_LOG_LEVEL: process.env.NEXT_PUBLIC_CTV_LOG_LEVEL,
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
    NEXT_PUBLIC_INFO_SITE_URL: process.env.NEXT_PUBLIC_INFO_SITE_URL,
    NEXT_PUBLIC_CLERK_SIGN_IN_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_URL,
    NEXT_PUBLIC_CLERK_SIGN_UP_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_URL,
    NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
  },

  // runtimeEnv: {
  //   YOUTUBE_API_KEY: process.env.YOUTUBE_API_KEY,
  //   DATABASE_URL: process.env.DATABASE_URL,
  //   NODE_ENV: process.env.NODE_ENV,
  //   SEARCHAPI_API_KEY: process.env.SEARCHAPI_API_KEY,
  //   VERCEL_PROJECT_PRODUCTION_URL: process.env.VERCEL_PROJECT_PRODUCTION_URL,
  //   NEXT_PUBLIC_CTV_LOG_LEVEL: process.env.NEXT_PUBLIC_CTV_LOG_LEVEL,
  //   NEXT_PUBLIC_INFO_SITE_URL: process.env.NEXT_PUBLIC_INFO_SITE_URL,
  //   CTV_DRIZZLE_LOG: process.env.CTV_DRIZZLE_LOG,
  //   TRIGGER_SECRET_KEY: process.env.TRIGGER_SECRET_KEY,
  //   TRIGGER_PROJECT_ID: process.env.TRIGGER_PROJECT_ID,
  //   TRIGGER_QUEUE_CONCURRENCY_LIMIT:
  //     process.env.TRIGGER_QUEUE_CONCURRENCY_LIMIT,
  //   ICHIRAN_API_URL: process.env.ICHIRAN_API_URL,
  //   RESEND_API_KEY: process.env.RESEND_API_KEY,
  //   RESEND_GENERAL_AUDIENCE_ID: process.env.RESEND_GENERAL_AUDIENCE_ID,
  //   NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY:
  //     process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  //   STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY,
  //   STRIPE_WEBHOOK_SECRET: process.env.STRIPE_WEBHOOK_SECRET,
  //   NEXT_PUBLIC_CLERK_SIGN_IN_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_URL,
  //   NEXT_PUBLIC_CLERK_SIGN_UP_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_URL,
  // },
  /**
   * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation. This is especially
   * useful for Docker builds.
   */
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  /**
   * Makes it so that empty strings are treated as undefined. `SOME_VAR: z.string()` and
   * `SOME_VAR=''` will throw an error.
   */
  emptyStringAsUndefined: true,
});
